import { render, staticRenderFns } from "./present-dish-edit.vue?vue&type=template&id=0771ab5b&scoped=true&"
import script from "./present-dish-edit.vue?vue&type=script&lang=js&"
export * from "./present-dish-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0771ab5b",
  null
  
)

export default component.exports